import React from "react";
import { Box, Card, Container, Grid, Stack, Typography } from "@mui/material";
import Image from "../../image";
import { useResponsive } from "../../../hooks/use-responsive";
import UserEmailIntegration from "./UserEmailIntegration";

function UserEmailLogin() {
  const mdUp = useResponsive("up", "md");
  return (
    <>


      <Container maxWidth={false} sx={{
        backgroundColor: "#1D53E7",
        padding: { sm: "10px", md: "40px" },
        backgroundImage: 'url("/assets/signup_bg.svg")', // Replace with the actual image URL
        backgroundSize: "cover", // Adjust as needed
        backgroundPosition: "center", // Adjust as needed
        minHeight: !mdUp ?"105vh": null,
      }} >

        <Grid
          container
          spacing={{ xs: 6, md: 6 }}
          columns={{ xs: 6, sm: 6, md: 12 }}
        >
          {mdUp && <Grid item xs={12} md={6} lg={6}>
            <Stack direction="column" spacing={2}>
              <Typography
                sx={{
                  color: "white",
                  fontFamily: "Roboto Flex",
                  fontStyle: "italic",
                  fontWeight: 700,
                  fontSize:'48px'
                }}
              >
                
                <span style={{ color: "#C7F760", fontStyle: "italic" }}>
                  {" "}
                  Welcome{" "}
                </span>{" "} Back!
              </Typography>
              <Typography
                sx={{
                  color: "white",
                  fontSize: 18,
                  fontFamily: "Roboto Flex",
                  fontWeight: "400",
                  wordWrap: "break-word",
                }}
              >
                Sign in to access your personalized MegaConnect dashboard and continue your journey into the future of technology.
              </Typography>
              <Image
                src="/assets/LoginIllustartion.svg"
                alt="signup_email_img"
                style={{ borderRadius: 15 }}
              />
            </Stack>
          </Grid>}
          {mdUp && <Grid item xs={12} md={6} lg={6}>
            <Card
              sx={{
                borderRadius: 5,
                p: { xs: 3, md: 5, lg: 5 },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  // mt: 3,
                }}
              >
                <Image src="/assets/MegaconnectLOGO-06.svg" alt="logo" />
              </Box>
              <UserEmailIntegration />
            </Card>
          </Grid>}
          {!mdUp && <Grid item xs={12} md={6} lg={6}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "105vh", // Full screen height
            }} >
            <Card
              sx={{
                borderRadius: 5,
                p: { xs: 3, sm: 5, lg: 5 },
                width: "100%", // Take full width in mobile view
                // maxWidth: "400px", // Set a max-width for better appearance
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  // mt: 3,
                }}
              >
                <Image src="/assets/MegaconnectLOGO-06.svg" alt="logo" />
              </Box>
              <UserEmailIntegration />
            </Card>
          </Grid>}
        </Grid>
      </Container>
    </>
  );
}

export default UserEmailLogin;
